import { endpoints, baseurl } from "../Utils/Constants";
import { toApiDate } from "../Utils/DateTime";

const authHeaders = (token) => ({
  "ngrok-skip-browser-warning": "true",
  Authorization: `Bearer ${token}`,
});

/** List page — one row per clinic organization + Organization/Provider/Facility totals. */
export const getValueBasedCareOrganizations = async (token, signal) => {
  const url = `${baseurl}${endpoints.GET_VALUE_BASED_CARE_ORGANIZATIONS}`;
  const response = await fetch(url, { method: "GET", headers: authHeaders(token), signal });
  return response.json();
};

/**
 * Detail page — patient cohort + "Age vs Dx (ICD-10)" aggregation for one organization.
 * @param {object} filters { organizationId, insurance, provider, location, startDate, endDate, dxCode, medications: string[] }
 */
export const getValueBasedCareAnalytics = async (token, filters = {}, signal) => {
  const params = new URLSearchParams();
  if (filters.organizationId) params.set("organization_id", filters.organizationId);
  if (filters.insurance) params.set("insurance", filters.insurance);
  if (filters.provider) params.set("provider", filters.provider);
  if (filters.location) params.set("location", filters.location);
  if (filters.startDate) params.set("start_date", toApiDate(filters.startDate));
  if (filters.endDate) params.set("end_date", toApiDate(filters.endDate));
  if (filters.dxCode) params.set("dx_code", filters.dxCode);
  (filters.medications || []).forEach((m) => m && params.append("medication", m));

  const qs = params.toString();
  const url = `${baseurl}${endpoints.GET_VALUE_BASED_CARE_ANALYTICS}${qs ? `?${qs}` : ""}`;
  const response = await fetch(url, { method: "GET", headers: authHeaders(token), signal });
  return response.json();
};

/** Distinct insurances / providers / locations, optionally scoped to one organization. */
export const getValueBasedCareFilters = async (token, organizationId, signal) => {
  const qs = organizationId ? `?organization_id=${encodeURIComponent(organizationId)}` : "";
  const url = `${baseurl}${endpoints.GET_VALUE_BASED_CARE_FILTERS}${qs}`;
  const response = await fetch(url, { method: "GET", headers: authHeaders(token), signal });
  return response.json();
};
